const name = 'module/novaposhta';

export const GET_MODULES_CONFIGURATION_REQUEST = `${name}/GET_MODULES_CONFIGURATION_REQUEST`;
export const GET_MODULES_CONFIGURATION_SUCCESS = `${name}/GET_MODULES_CONFIGURATION_SUCCESS`;
export const GET_MODULES_CONFIGURATION_FAILURE = `${name}/GET_MODULES_CONFIGURATION_FAILURE`;

export const UPDATE_MODULES_CONFIGURATION_REQUEST = `${name}/UPDATE_MODULES_CONFIGURATION_REQUEST`;
export const UPDATE_MODULES_CONFIGURATION_SUCCESS = `${name}/UPDATE_MODULES_CONFIGURATION_SUCCESS`;
export const UPDATE_MODULES_CONFIGURATION_FAILURE = `${name}/UPDATE_MODULES_CONFIGURATION_FAILURE`;

export const NOVAPOSHTA_TTN_CREATE_REQUEST = `${name}/NOVAPOSHTA_TTN_CREATE_REQUEST`;
export const NOVAPOSHTA_TTN_CREATE_SUCCESS = `${name}/NOVAPOSHTA_TTN_CREATE_SUCCESS`;
export const NOVAPOSHTA_TTN_CREATE_FAILURE = `${name}/NOVAPOSHTA_TTN_CREATE_FAILURE`;

export const GET_DELIVERY_DATE_REQUEST = `${name}/GET_DELIVERY_DATE_REQUEST`;
export const GET_DELIVERY_DATE_SUCCESS = `${name}/GET_DELIVERY_DATE_SUCCESS`;
export const GET_DELIVERY_DATE_FAILURE = `${name}/GET_DELIVERY_DATE_FAILURE`;

export const GET_DELIVERY_COST_REQUEST = `${name}/GET_DELIVERY_COST_REQUEST`;
export const GET_DELIVERY_COST_SUCCESS = `${name}/GET_DELIVERY_COST_SUCCESS`;
export const GET_DELIVERY_COST_FAILURE = `${name}/GET_DELIVERY_COST_FAILURE`;

export const NOVAPOSHTA_MARKING_PRINT_LINK_REQUEST = `${name}/NOVAPOSHTA_MARKING_PRINT_LINK_REQUEST`;
export const NOVAPOSHTA_MARKING_PRINT_LINK_SUCCESS = `${name}/NOVAPOSHTA_MARKING_PRINT_LINK_SUCCESS`;
export const NOVAPOSHTA_MARKING_PRINT_LINK_FAILURE = `${name}/NOVAPOSHTA_MARKING_PRINT_LINK_FAILURE`;

export default name;
